import customAxios from "./axiosConfig"

const InvoiceLayoutService = {
  list (params) {
    const api_url = window.Urls['invoicelayout-list']()
    return customAxios.get(api_url, { params: params })
  },
  listV2 (params) {
    const api_url = window.Urls['invoicelayout-list']()
    return customAxios.get(api_url, { params: params })
  },
  // TODO fix v3 pagination
  listV3 (params) {
    const api_url = window.Urls['v3:invoicelayout-list']()
    return customAxios.get(api_url, { params: params })
  },
  create (data) {
    const api_url = window.Urls['invoicelayout-list']()
    return customAxios.post(api_url, data)
  },
  update (id, data){
    const api_url = window.Urls['invoicelayout-detail'](id)
    return customAxios.put(api_url, data)
  },
  get_current_layouts () {
    const api_url = window.Urls['invoicelayout-get-current-layouts']()
    return customAxios.get(api_url)
  },
  get_default_layout_values () {
    const api_url = window.Urls['invoicelayout-get-default-layout-values']()
    return customAxios.get(api_url)
  },
  get_layout_fonts () {
    const api_url = window.Urls['invoicelayout-get-layout-fonts']()
    return customAxios.get(api_url)
  },
  // getInvoicePdf (pk) {
  //   const api_url = window.Urls['invoices_pdf'](pk)
  //   return customAxios.get(api_url)
  // },
  getInvoicePDFb64 (pk, controllerSignal) {
    const api_url = window.Urls['invoices_pdf_view'](pk)
    return customAxios.post(api_url, false, { signal: controllerSignal.signal, responseType: 'blob' }).then((response) => {
      return this._blobToBase64(response.data)
    })
  },
  getQuotationPDFb64 (pk, controllerSignal) {
    const api_url = window.Urls['quotations:quotations_pdf_view'](pk)
    return customAxios.post(api_url, false, { signal: controllerSignal.signal, responseType: 'blob' }).then((response) => {
      return this._blobToBase64(response.data)
    })
  },
  previewPdf (payload) {
    const api_url = window.Urls['unsaved_invoice']()
    return customAxios.post(api_url, payload, { responseType: 'blob' }).then((response) => {
      return this._blobToBase64(response.data)
    })
  },
  async _blobToBase64 (blob) {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        resolve(reader.result)
      }
    })
  }
}

export default InvoiceLayoutService
